const contractListFields = [
  {
    key: 'number',
    label: 'Nomor Kontrak',
    isRedirectable: true,
  },
  {
    key: 'status.name',
    label: 'Status',
  },
  {
    key: 'version.addendum',
    label: 'Addendum',
  },
  {
    key: 'reference',
    label: 'Referensi',
  },
  {
    key: 'effective_date',
    label: 'Tanggal Mulai',
  },
  {
    key: 'expired_date',
    label: 'Tanggal Berakhir',
  },
]

export default contractListFields
